import React from 'react';
import { Box, Heading, Paragraph } from 'components';
import type { ShipmentQuoteAppT } from 'apps/shipmentQuote/app';
import { formatDate, formatPrice } from 'utils/formatStrings';

interface PriceSectionProps {
  quote: ShipmentQuoteAppT;
}

export const PriceSection = ({ quote }: PriceSectionProps) => {
  // TODO: currency may be added at the quote level from backend in the future
  // const { currency } = quote;
  const { currency } = quote.productQuotes.apps[0];

  return (
    <Box
      pl={8}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        flex: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Heading level={3} size='large'>
          TOTAL PRICE:{' '}
        </Heading>
        <Heading level={3} size='large'>
          <span style={{ fontWeight: 'normal' }}>
            {formatPrice(quote.totalCost / 100, currency)}
          </span>
        </Heading>
      </Box>
      <Box mt={4}>
        <Heading level='5' size='small'>
          Created Date
        </Heading>
        <Paragraph>{formatDate(quote.createdAt)}</Paragraph>
      </Box>
      <Box mt={4}>
        <Heading level='5' size='small'>
          Estimated Delivery Date
        </Heading>
        <Paragraph>{formatDate(quote.deliveryDate)}</Paragraph>
      </Box>
    </Box>
  );
};
